export const sessionStorageKeyConstants = Object.freeze({
  ID_TOKEN: 'idToken',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  TABLEAU_TOKEN: 'tableauToken',
  LOGIN_ATTEMPTS_COUNT: 'loginAttemptsCount',
  SELECTED_CLIENT: 'selectedClient',
  SELECTED_WAREHOUSE_CODES: 'selectedWarehouseCodes',
})
